import { Loading } from "components/panels";
import React from "react";
import { useApi } from "utilities/hookutils";
import ExportRowCard from "./ExportRowCard";
import { getCacheFriendlyInstruction } from "../Filters/InstructionHelpers";
import { type AxiosPromise } from "axios";

interface Props<TInstruction> {
  instruction: TInstruction
  exportOptionsApi: (instruction: TInstruction) => AxiosPromise<server.dto.ApiResponseWrapper<server.dto.ExportOption[]>>
}

const ExportModal = <TInstruction extends any>(props: Props<TInstruction>) => {
  const cacheKey = getCacheFriendlyInstruction(props.instruction);

  const api = useApi(async () => props.exportOptionsApi(props.instruction), [cacheKey]);

  if (api.isLoading) {
    return <Loading />;
  }

  if (api.data.data.length === 0) {
    return <div>{RESX.Template.NoTemplatesAvailable}</div>;
  }

  return <div className="scrollbox-auto" style={{ maxHeight: 600 }}>
    <div className="list-with-gaps card-layout">
      <div className="list-with-gaps-body">
        {api.data.data.map((exportOption, idx) => (
          <ExportRowCard
            key={idx}
            exportOption={exportOption}
          />
        ))}
      </div>
    </div>
  </div>;
};

export default ExportModal;